import { render, staticRenderFns } from "./staticPayTable.vue?vue&type=template&id=53a4556a&scoped=true"
import script from "./staticPayTable.vue?vue&type=script&lang=js"
export * from "./staticPayTable.vue?vue&type=script&lang=js"
import style0 from "./staticPayTable.vue?vue&type=style&index=0&id=53a4556a&lang=css"
import style1 from "./staticPayTable.vue?vue&type=style&index=1&id=53a4556a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4556a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a4556a')) {
      api.createRecord('53a4556a', component.options)
    } else {
      api.reload('53a4556a', component.options)
    }
    module.hot.accept("./staticPayTable.vue?vue&type=template&id=53a4556a&scoped=true", function () {
      api.rerender('53a4556a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/staticPayTable.vue"
export default component.exports